import {
  PiCaretDown,
  PiScreencast,
  PiShareNetwork,
  PiShieldCheckeredDuotone,
  PiUsersThree,
  PiLockSimpleDuotone,
  PiHouseLight
} from "react-icons/pi";

const menuData = [
  {
    item: "Dashboard",
    icon: <PiHouseLight />,
    role: ["ROLE_USER"],
    path: "/",
    directlyLink: true,
    category: [
      {
        title: "Statistics Agent",
        path: "/agentinsight",
        role: ["ROLE_SUPERADMIN"],
      },
    ],
  },
  {
    item: "Réseau",
    icon: <PiShareNetwork />,
    category: [
      {
        title: "Actifs",
        icon: <PiCaretDown />,
        submenu: [
          {
            title: "Certificats",
            path: "/certificats",
            role: ["ROLE_CERTIFICATS"],
          },
          {
            title: "Cisco",
            path: "/equipements/cisco",
            role: ["ROLE_EQUIPEMENT"],
          },
          {
            title: "Hp",
            path: "/equipements/hp",
            role: ["ROLE_HP"],
          },
        ],
      },
      {
        title: "Monitoring",
        icon: <PiCaretDown />,
        submenu: [
          {
            title: "Auvik",
            path: "/auvik",
            role: ["ROLE_AUVIK"]
          },
          {
            title: "Meraki",
            path: "/meraki",
            role: ["ROLE_MERAKI"],
          },
          {
            title: "Liaison Ethernet",
            path: "/liaisonethernet",
            role: ["ROLE_IELO"],
          },
          {
            title: "Smart Account",
            path: "/smart_account",
            role: ["ROLE_SMARTACCOUNT"],
          },
          {
            title: "Ubiquiti",
            path: "/ubiquiti",
            role: ["ROLE_UBIQUITI"],
          }
        ],
      },
      {
        title: "Reporting",
        icon: <PiCaretDown />,
        submenu: [
          {
            title: "Cisco",
            path: "/hardware",
            role: ["ROLE_ANALYTICS"],
          },
        ],
      },
    ],
  },
  {
    item: "Sécurité",
    icon: <PiShieldCheckeredDuotone />,
    category: [
      {
        title: "Actifs",
        icon: <PiCaretDown />,
        submenu: [
          {
            title: "Licences Palo",
            path: "/licences/palo",
            role: ["ROLE_PALO"],
          },
          {
            title: "Liste Secure Endpoint",
            path: "/secure_endpoint/equipement",
            role: ["ROLE_AMP"],
          },
          {
            title: "Palo",
            path: "/firewall/palo",
            role: ["ROLE_PALO"],
          },
        ],
      },
      {
        title: "Monitoring",
        icon: <PiCaretDown />,
        submenu: [
          {
            title: "Cato",
            path: "/cato",
            role: ["ROLE_SUPERADMIN"],
          },
          {
            title: "Secure Endpoint",
            path: "/secure_endpoint/events",
            role: ["ROLE_AMP"],
          },
          {
            title: "Securonix",
            path: "/securonix",
            role: ["ROLE_SUPERADMIN"],
          },
          {
            title: "Sentinel One",
            path: "/sentinelone",
            role: ["ROLE_SUPERADMIN"],
          },
          {
            title: "SOC",
            path: "https://a1t10elitha.securonix.net/Snypr/",
          },
          {
            title: "Umbrella",
            path: "/umbrella",
            role: ["ROLE_UMBRELLA"],
          },
        ],
      },
      {
        title: "Reporting",
        icon: <PiCaretDown />,
        submenu: [
          {
            title: "Cisco",
            path: "/hardware_firewall",
            role: ["ROLE_WEBEX", "ROLE_POLY"],
          },
        ],
      },
      {
        title: "DAST",
        path: "/dast",
        role: ["ROLE_SCAN"]
      }
    ],
  },
  {
    item: "Workplace",
    icon: <PiScreencast />,
    category: [
      {
        title: "Actifs",
        icon: <PiCaretDown />,
        submenu: [
          {
            title: "Visio",
            path: "/visio",
            role: ["ROLE_WEBEX", "ROLE_POLY"],
          },
          {
            title: "Barco ",
            path: "/equipements/barco",
            role: ["ROLE_BARCO"],
          },
          {
            title: "Evoko",
            path: "/equipements/evoko",
            role: ["ROLE_EVOKO"],
          },
          {
            title: "Lenovo ",
            path: "/equipements/lenovo",
            role: ["ROLE_LENOVO"],
          },
          {
            title: "Poly",
            path: "/equipements/poly",
            role: ["ROLE_POLY"],
          },
        ],
      },
      {
        title: "Monitoring",
        icon: <PiCaretDown />,
        submenu: [
          {
            title: "IoT",
            path: "/IoT",
            role: ["ROLE_WEBEX", "ROLE_MERAKI"],
          },
          {
            title: "Microsoft",
            path: "/microsoft",
            role: ["ROLE_0365"],
          },
          {
            title: "Statistics",
            path: "/statistics",
            role: ["ROLE_WEBEX_CALLING"],
          },
          {
            title: "Webex",
            path: "/webex",
            role: ["ROLE_WEBEX"],
          },
        ],
      },
      {
        title: "Reporting",
        icon: <PiCaretDown />,
        submenu: [
          {
            title: "Cisco",
            path: "/hardware_visio",
            role: ["ROLE_WEBEX", "ROLE_POLY"],
          },
        ],
      },
    ],
  },
  {
    item: "Services Managés",
    icon: <PiUsersThree />,
    category: [
      {
        title: "Actifs",
        icon: <PiCaretDown />,
        submenu: [
          {
            title: "Smartnet",
            path: "/smartnet",
          },
          {
            title: "Subscription",
            path: "/subscription",
          },
        ],
      },
      {
        title: "Monitoring",
        icon: <PiCaretDown />,
        submenu: [
          {
            title: "Portail",
            path: "https://servicedesk.elit-technologies.fr",
          },
          {
            title: "Tickets",
            path: "/tickets",
            role: ["ROLE_INCIDENT"],
          },
          {
            title: "Timeline",
            path: "/timeline",
          },
        ]
      },
      {
        title: "Documentation",
        path: "/files_manager",
      },
      {
        title: "Parking",
        path: "/parking",
        role: ["ROLE_PARKING"]
      }
    ],
  },
  {
    item: "Admin",
    icon: <PiLockSimpleDuotone />,
    role: ["ROLE_SUPERADMIN"],
    category: [
      {
        title: "Logs",
        path: "/logs",
        role: ["ROLE_SUPERADMIN"],
      },
      {
        title: "Statistics Agent",
        path: "/agentinsight",
        role: ["ROLE_SUPERADMIN"],
      },
    ],
  },
];

export default menuData;
